export default [
  {
    key: 'none',
    value: 'No assignee',
    icon: {
      name: 'close',
    },
  },
  {
    key: 'any',
    value: 'All assignees',
    icon: {
      name: 'close',
    },
  },
  {
    key: 'me',
    value: 'Me',
    icon: {
      name: 'close',
    },
  },
]
